import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/layout/Navbar';
import SiteFooter from '../../components/layout/Footer';

const plans = [
  {
    id: 'pack_one', name: 'Pack One',
    priceEUR: '€32', priceINR: '₹2,999', period: '/month',
    contacts: '2,000', sends: '6,000', verify: '2,000', accounts: '10', warmup: '10',
    desc: 'Perfect for small businesses and startups starting email outreach.',
    features: ['2,000 contacts upload limit','6,000 email sends per month','2,000 email verifications','Up to 10 email accounts','10 warmup accounts','A/B Testing','Campaign Scheduling','CRM Pipeline (7 stages)','Email Analytics & Reports','Bulk CSV Verifier','Standard Support'],
  },
  {
    id: 'pack_two', name: 'Pack Two', popular: true,
    priceEUR: '€78', priceINR: '₹6,999', period: '/month',
    contacts: '30,000', sends: '90,000', verify: '30,000', accounts: '100', warmup: '100',
    desc: 'Designed for growing businesses and marketing teams.',
    features: ['30,000 contacts upload limit','90,000 email sends per month','30,000 email verifications','Up to 100 email accounts','100 warmup accounts','A/B Testing + Auto-Winner','Campaign Scheduling','Advanced CRM Pipeline','Advanced Analytics & Reports','Bulk CSV Verifier','Priority Support'],
  },
  {
    id: 'pack_advanced', name: 'Pack Advanced',
    priceEUR: '€144', priceINR: '₹12,999', period: '/month',
    contacts: 'Unlimited', sends: '150,000', verify: '50,000', accounts: 'Unlimited', warmup: 'Unlimited',
    desc: 'Built for agencies and enterprises managing large audiences.',
    features: ['Unlimited contacts upload','150,000 email sends per month','50,000 email verifications','Unlimited email accounts','Unlimited warmup accounts','A/B Testing + Auto-Winner','Campaign Scheduling','Advanced CRM Pipeline','Full Analytics Suite','Bulk CSV Verifier','Dedicated Account Manager'],
  },
];

const compareRows = [
  ['Contacts Upload',     '2,000',   '30,000',   'Unlimited'],
  ['Email Sends / month', '6,000',   '90,000',   '150,000'],
  ['Email Verifications', '2,000',   '30,000',   '50,000'],
  ['Email Accounts',      '10',      '100',      'Unlimited'],
  ['Warmup Accounts',     '10',      '100',      'Unlimited'],
  ['A/B Testing',         '✓',       '✓',        '✓'],
  ['CRM Pipeline',        '✓',       '✓',        '✓'],
  ['Campaign Scheduling', '✓',       '✓',        '✓'],
  ['Analytics & Reports', 'Standard','Advanced', 'Full Suite'],
  ['CSV Import / Export', '✓',       '✓',        '✓'],
  ['Support',             'Standard','Priority', 'Dedicated Manager'],
];

export default function Plans() {
  const [currency, setCurrency] = useState('EUR');

  return (
    <div style={{ background: '#0A0A0A', minHeight: '100vh', color: '#fff' }}>
      <Navbar />

      {/* Hero */}
      <section style={{ paddingTop: 140, paddingBottom: 60, textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%,-50%)', width: 600, height: 600, background: 'radial-gradient(circle, rgba(46,204,113,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ display: 'inline-block', background: 'rgba(46,204,113,0.08)', border: '1px solid rgba(46,204,113,0.25)', borderRadius: 20, padding: '5px 16px', fontSize: 11, fontWeight: 800, color: '#2ECC71', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 20 }}>Pricing</div>
        <h1 style={{ fontSize: 58, fontWeight: 900, marginBottom: 16, letterSpacing: -2 }}>Plans for Every <span style={{ color: '#2ECC71' }}>Business</span></h1>
        <p style={{ fontSize: 16, color: '#666', maxWidth: 520, margin: '0 auto 28px' }}>No hidden fees. Upgrade anytime. GST applicable for Indian clients.</p>

        {/* Currency toggle */}
        <div style={{ display: 'inline-flex', background: '#111', border: '1px solid rgba(46,204,113,0.2)', borderRadius: 50, padding: 4, gap: 4 }}>
          {[['EUR','🌍 EUR (€)'],['INR','🇮🇳 INR (₹)']].map(([code, label]) => (
            <button key={code} onClick={() => setCurrency(code)} style={{ padding: '8px 24px', borderRadius: 50, border: 'none', background: currency === code ? '#2ECC71' : 'transparent', color: currency === code ? '#000' : '#888', fontWeight: currency === code ? 800 : 500, fontSize: 13, cursor: 'pointer', transition: 'all 0.2s' }}>
              {label}
            </button>
          ))}
        </div>

        {currency === 'INR' && (
          <div style={{ marginTop: 12, fontSize: 12, color: '#555' }}>
            + GST applicable · SGST+CGST for Tamil Nadu · IGST for other states · 0% for international
          </div>
        )}
      </section>

      {/* Plan Cards */}
      <section style={{ padding: '0 60px 80px', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24, maxWidth: 1200, margin: '0 auto' }}>
        {plans.map(plan => (
          <div key={plan.id} style={{ background: '#111', border: `2px solid ${plan.popular ? '#2ECC71' : 'rgba(46,204,113,0.12)'}`, borderRadius: 24, padding: 36, position: 'relative', transition: 'all 0.3s', boxShadow: plan.popular ? '0 0 50px rgba(46,204,113,0.12)' : 'none' }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(46,204,113,0.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = plan.popular ? '0 0 50px rgba(46,204,113,0.12)' : 'none'; }}>

            {plan.popular && <div style={{ position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)', background: '#2ECC71', color: '#000', padding: '5px 22px', borderRadius: 20, fontSize: 11, fontWeight: 900, whiteSpace: 'nowrap' }}>⭐ MOST POPULAR</div>}

            <div style={{ fontSize: 12, fontWeight: 800, color: '#2ECC71', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 10 }}>{plan.name}</div>

            {/* Price display — both currencies */}
            <div style={{ marginBottom: 4 }}>
              <div style={{ fontSize: 52, fontWeight: 900, letterSpacing: -2, color: '#fff' }}>
                {currency === 'EUR' ? plan.priceEUR : plan.priceINR}
                <span style={{ fontSize: 16, fontWeight: 400, color: '#555' }}>{plan.period}</span>
              </div>
              <div style={{ fontSize: 13, color: '#444', marginTop: 4 }}>
                {currency === 'EUR' ? `Also available at ${plan.priceINR}/mo for India` : `International price ${plan.priceEUR}/mo`}
                {currency === 'INR' && <span style={{ color: '#F39C12', marginLeft: 6 }}>+ GST</span>}
              </div>
            </div>

            <p style={{ fontSize: 13, color: '#666', marginBottom: 24, lineHeight: 1.6, marginTop: 12 }}>{plan.desc}</p>

            {/* Key limits */}
            <div style={{ background: 'rgba(46,204,113,0.04)', border: '1px solid rgba(46,204,113,0.1)', borderRadius: 12, padding: '14px 16px', marginBottom: 24 }}>
              {[['📋','Contacts Upload',plan.contacts],['📤','Email Sends/mo',plan.sends],['✅','Verifications/mo',plan.verify],['🔗','Email Accounts',plan.accounts],['🌡️','Warmup Accounts',plan.warmup]].map(([icon,label,val]) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,0.03)', fontSize: 13 }}>
                  <span style={{ color: '#666' }}>{icon} {label}</span>
                  <span style={{ color: '#2ECC71', fontWeight: 800 }}>{val}</span>
                </div>
              ))}
            </div>

            {/* Features */}
            <ul style={{ listStyle: 'none', marginBottom: 28 }}>
              {plan.features.map(feat => (
                <li key={feat} style={{ display: 'flex', gap: 8, padding: '5px 0', fontSize: 13, color: '#ccc', borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                  <span style={{ color: '#2ECC71', fontWeight: 900, flexShrink: 0 }}>✓</span>{feat}
                </li>
              ))}
            </ul>

            <Link to="/client/register" style={{ display: 'block', textAlign: 'center', padding: '14px', background: plan.popular ? '#2ECC71' : 'transparent', border: `2px solid #2ECC71`, borderRadius: 12, color: plan.popular ? '#000' : '#2ECC71', fontWeight: 900, fontSize: 15, textDecoration: 'none', transition: 'all 0.2s', boxShadow: plan.popular ? '0 0 24px rgba(46,204,113,0.25)' : 'none' }}>
              Get Started →
            </Link>
          </div>
        ))}
      </section>

      {/* GST info for Indian clients */}
      <section style={{ padding: '0 60px 40px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ background: 'rgba(243,156,18,0.05)', border: '1px solid rgba(243,156,18,0.2)', borderRadius: 16, padding: '20px 28px', display: 'flex', gap: 16, alignItems: 'flex-start' }}>
          <span style={{ fontSize: 22 }}>🇮🇳</span>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#F39C12', marginBottom: 6 }}>GST Information for Indian Clients</div>
            <div style={{ fontSize: 13, color: '#888', lineHeight: 1.8 }}>
              INR pricing is exclusive of GST. Applicable GST will be added at checkout based on your state:
              <span style={{ color: '#ccc' }}> Tamil Nadu clients → SGST 9% + CGST 9% (18% total) · Other states → IGST 18% · International → No GST.</span>
              <span style={{ color: '#F39C12' }}> GST invoice provided for all Indian transactions.</span>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section style={{ padding: '20px 60px 80px', maxWidth: 1000, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 36, fontWeight: 900, marginBottom: 40 }}>Full <span style={{ color: '#2ECC71' }}>Comparison</span></h2>
        <div style={{ background: '#111', border: '1px solid rgba(46,204,113,0.1)', borderRadius: 20, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: 'rgba(46,204,113,0.06)', borderBottom: '1px solid rgba(46,204,113,0.12)' }}>
                <th style={{ padding: '16px 20px', textAlign: 'left', color: '#888', fontWeight: 700 }}>Feature</th>
                {plans.map(p => (
                  <th key={p.id} style={{ padding: '16px 20px', textAlign: 'center', color: '#2ECC71', fontWeight: 800 }}>
                    {p.name}<br />
                    <span style={{ fontSize: 11, color: '#555', fontWeight: 400 }}>
                      {currency === 'EUR' ? p.priceEUR : p.priceINR}/mo
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {compareRows.map(([feat, ...vals], i) => (
                <tr key={feat} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)', background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)' }}>
                  <td style={{ padding: '12px 20px', color: '#ccc', fontWeight: 500 }}>{feat}</td>
                  {vals.map((v, j) => (
                    <td key={j} style={{ padding: '12px 20px', textAlign: 'center', color: v === '✓' || v === 'Unlimited' ? '#2ECC71' : '#ccc', fontWeight: v === '✓' || v === 'Unlimited' ? 800 : 400 }}>{v}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Custom Plan */}
      <section style={{ padding: '0 60px 80px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ background: 'linear-gradient(135deg, rgba(46,204,113,0.07), rgba(46,204,113,0.02))', border: '1px solid rgba(46,204,113,0.2)', borderRadius: 24, padding: '60px', textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 20 }}>🏢</div>
          <h2 style={{ fontSize: 38, fontWeight: 900, marginBottom: 14 }}>Need a <span style={{ color: '#2ECC71' }}>Custom Plan</span>?</h2>
          <p style={{ fontSize: 15, color: '#777', maxWidth: 560, margin: '0 auto 36px', lineHeight: 1.9 }}>Every business is different. We'll build a custom plan with exactly the contacts, sends, verifications, and support level your business needs.</p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
            <a href="mailto:support@msdiscoveries.com" style={{ padding: '14px 32px', background: '#2ECC71', borderRadius: 10, color: '#000', fontWeight: 900, textDecoration: 'none', fontSize: 14 }}>📧 Email Us</a>
            <a href="tel:+919443724724" style={{ padding: '14px 32px', border: '2px solid #2ECC71', borderRadius: 10, color: '#2ECC71', fontWeight: 700, textDecoration: 'none', fontSize: 14 }}>📞 +91 9443724724</a>
            <Link to="/contact" style={{ padding: '14px 32px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, color: '#888', fontWeight: 600, textDecoration: 'none', fontSize: 14 }}>Contact Form →</Link>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
